import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import * as _ from 'lodash';
import { ModalDialogComponent } from '@vg-constellation/angular-19/modal-dialog';
import {
  getMessageCodeByValue,
  getMessageTypeValues,
} from '../../../core/utility/message-enum.util';
import { ResponsiveBreakpointService } from '../../../services/breakpoint/responsive-breakpoint.service';

@Component({
  selector: 'app-message-detail-search-modal',
  templateUrl: './message-detail-search-modal.component.html',
  styleUrl: './message-detail-search-modal.component.scss',
  standalone: false,
})
export class MessageDetailSearchModalComponent {
  showErrors: boolean = false as boolean;
  isWaiting: boolean = false as boolean;
  messageTypes: string[] = getMessageTypeValues();
  //search button loading emitter
  @Output() formSubmitClicked = new EventEmitter<Record<string, string>>();

  @ViewChild('message_detail_search_modal') messageSearchModel!: ModalDialogComponent;

  formGroup: FormGroup = new FormGroup({
    message_number: new FormControl(''),
    message_type: new FormControl(''),
    show_messages: new FormControl(''),
  });

  constructor(protected responsive: ResponsiveBreakpointService) {}

  /**
   * Handle form submission
   */
  submitForm(event: Event): void {
    event.preventDefault();

    const formValues = this.formGroup.value as Record<string, string>;

    // Validate: Check if at least one field has a value
    if (!this.hasAnyValue(formValues)) {
      this.showErrors = true;
      return;
    }
    this.isWaiting = true;

    // Transform form data for API
    const transformedData = this.transformFormData(formValues);
    // Emit events and close modal
    this.formSubmitClicked.emit(transformedData);
    this.cancelButtonHandler();
  }

  /**
   * Check if form has any non-empty values
   */
  private hasAnyValue(formValues: Record<string, string>): boolean {
    return Object.values(formValues).some((value) => !_.isEmpty(value));
  }

  /**
   *  Transform form data for API submission
   */
  private transformFormData(formValues: Record<string, string>): Record<string, string> {
    const data = { ...formValues };

    // Transform message type
    if (data.message_type) {
      data.message_type = getMessageCodeByValue(data.message_type);
    }

    // Transform show_messages field
    if (data.show_messages === 'permanent') {
      data.permanent = 'true';
      delete data.show_messages;
    } else if (data.show_messages === 'verified') {
      data.verified = 'false';
      delete data.show_messages;
    }

    return data;
  }

  cancelButtonHandler() {
    this.messageSearchModel.closeDialogModal();
    this.showErrors = false;
    this.resetForm();
  }

  /**
   * PUBLIC METHOD: Can be called from parent
   */
  public openSearchModal(): void {
    this.messageSearchModel.openModalDialog();
  }

  // Reset form to initial state
  private resetForm(): void {
    this.formGroup.reset({
      message_number: '',
      message_type: '',
      show_messages: '',
    });
    this.isWaiting = false;
  }
}
